<div class="search-results" [ngClass]="{ narrowScreen: narrowScreen }">
	<large-download-modal
		[showModal]="showLargeDownloadModal"
		(close)="closeLargePdfModal($event)"
	>
	</large-download-modal>

	<search-bar
		[searchOnFilterChange]="true"
		[navigateToResultsOnSearch]="false"
	>
	</search-bar>
	<filter [isSearchResultsScreen]="true"></filter>
	<div class="content">
		<div class="title">
			<div class="result">
				<div>
					{{ searchTitle }}
				</div>
				@if (showCount) {
					<span class="count">{{ totalItems }}</span>
				}
			</div>
		</div>
		@if (inCompanyMode) {
		<localized-text-snippet
			class="result-info"
			text="{{ onlyShowingCompanies }}"
		>
		</localized-text-snippet>
		<div class="sort-download-group">
			<sort-control [companies]="companies" #sortControl></sort-control>
		@if (isDownloadEnabled && companies.length > 0) {
			<div class="export">
				<div
					class="button"
					[ngClass]="{ 'menu-open': showMenu }"
					(click)="setShowMenu($event)"
				>
					<div class="label" [ngClass]="{ 'menu-open': showMenu }">
						{{ download }}
					</div>
					<div
						class="icon"
						[ngClass]="{ 'menu-open': showMenu }"
					></div>
				</div>
				@if(showMenu){
				<div class="export-menu">
					@if(isDownloadDocumentEnabled){
					<div class="pdf-outer" (click)="downloadPdfClicked()">
						<div class="item pdf">
							<div class="icon pdf"></div>
							<div class="label">
								{{ downloadPDF }}
							</div>
						</div>
						<div class="subtitle">
							{{ searchResultsMayTake }}
						</div>
					</div>
					} @if(isInternalView){
					<div class="item" (click)="downloadWordDocument()">
						<div class="icon word"></div>
						<div class="label">
							{{ downloadWord }}
						</div>
					</div>
					}
					<div class="item" (click)="exportCompaniesAsCsv()">
						<div class="icon csv"></div>
						<div class="label">
							{{ downloadCSV }}
						</div>
					</div>
				</div>
				}
			</div>
			}
		</div>
		@if(badSearchPredicate) {
		<div class="bad-search">
			{{ sorry }}<span class="predicate">{{ badSearchPredicate }}</span
			>{{ sorryEnd }}
		</div>
		} @for(company of companies; track company.modelId){
		<div>
			<company-summary
				[company]="company"
				[tagCounts]="tagCounts"
			></company-summary>
			@if($last) {
			{{ loadCompleted($index) }}
			}
		</div>
		} } @else {
		<asset-table
			[assets]="assets"
			[availableColumns]="availableAssetColumns"
			[enableColumnSelection]="true"
			[enableCompanyNav]="true"
			(onSortChanged)="sortAsset($event)"
			[disableSort]="true"
			[fullWitdh]="true"
			[enableDownload]="true"
			[embeddedScroll]="true"
		></asset-table>
		}
	</div>
</div>
